/** @format — Sidebar collapse / expand control (design #737373) */

import React from "react";

const SIZE_CLASS = {
  sm: "w-[13.33px] h-[13.33px]",
  lg: "w-5 h-5",
};

export default function SidebarCollapseIcon({ expanded = false, className = "", size = "sm" }) {
  return (
    <svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${SIZE_CLASS[size] ?? SIZE_CLASS.sm} ${className}`}
      preserveAspectRatio="xMidYMid meet"
      aria-hidden
    >
      <path
        d="M4.91667 0.75V14.0833M0.75 2.41667C0.75 1.97464 0.925595 1.55072 1.23816 1.23816C1.55072 0.925595 1.97464 0.75 2.41667 0.75H12.4167C12.8587 0.75 13.2826 0.925595 13.5952 1.23816C13.9077 1.55072 14.0833 1.97464 14.0833 2.41667V12.4167C14.0833 12.8587 13.9077 13.2826 13.5952 13.5952C13.2826 13.9077 12.8587 14.0833 12.4167 14.0833H2.41667C1.97464 14.0833 1.55072 13.9077 1.23816 13.5952C0.925595 13.2826 0.75 12.8587 0.75 12.4167V2.41667Z"
        stroke="#737373"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {expanded ? (
        <path
          d="M5.08333 5.75L6.75 7.41667L5.08333 9.08333"
          stroke="#737373"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M9.91667 5.75L8.25 7.41667L9.91667 9.08333"
          stroke="#737373"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}
